import styled from "styled-components";

export const RadioSurvey = styled.div`
  margin: 0.4rem;

  #labelRadioSurvey {
    margin: 0.3rem;
    text-transform: capitalize;
  }
`;

export const ContainerIteration = styled.div`
  display: grid;
  grid-template-columns: 2, 1fr;
`;

export const GeneralStyle = styled.div`
  position: relative;
  align-items: center;
  justify-self: center;
  display: grid;
  margin: 1em;
  max-width: 600px;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  padding: 1em 2em;
  word-break: break-word;
  width: 100%;
  opacity: 0.95;
  box-shadow: ${({ editable }) =>
    editable && "0px 0px 10px rgba(0, 0, 0, 0.3);"};
  border-radius: 4px;
  background: ${({ colorBackground, theme }) =>
    colorBackground === theme.background.tertiary || colorBackground === "transparent" ? "transparent" : colorBackground};
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
    background: ${({ theme }) => theme.background.tertiary};
  }
  :hover .overlay-option {
    opacity: 1;
  }
  .overlay-option {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: ${({ theme }) => theme.background.overlay};
  }

  .bottom-buttons {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    @media only screen and (max-width: 475px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    }
  }
`;

export const EditSectionBannerBlock = styled.div`
  align-items: center;
  justify-self: center;
  display: grid;
  grid-template-columns: 1fr;
  font-size: 14px;
  border-radius: 5px;
  word-break: break-word;
  background: ${({ theme }) => theme.background.tertiary};
  hr {
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.neutral.gray[200]};
  }

  .wrapper-class {
    border: 1px solid #ced4da !important;
    background-color: ${({ theme }) => theme.neutral.white} !important;
  }
`;

export const UpperWrapperBannerBlock = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr;
  align-items: center;
  grid-gap: 1em;

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }

  #mText {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const QuestionWrapperBannerBlock = styled.div`
  display: grid;
  padding: 0.4em;
  align-items: center;

  label {
    font-weight: 700;
  }

  textarea {
    padding: 1rem;
    width: 100%;
    height: 6em;
    outline: 0;
    border: none;
    background: ${({ theme }) => theme.primaryGray};
    border-radius: 4px;
    box-sizing: border-box;
    font-size: small;
    color: ${({ theme }) => theme.primaryIconColor};
    resize: none;
  }
`;
export const SelectsSectionBannerBlock = styled.div`
  display: grid;
  padding: 0.4em;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1em;

  label {
    font-size: small;
  }
`;

export const LowerWrapperBannerBlock = styled.div`
  display: grid;
  padding: 0.4em;
  align-items: center;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  margin-top: 25px;
  @media only screen and (max-width: 495px) {
    flex-direction: column;
    align-items: center;
  }
  .left-container {
    margin-left: 20px;
    display: flex;
    width: 70%;
  }
  .right-container {
    display: flex;
    width: 30%;
    justify-content: end;
  }
`;

export const ContainerTitle = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.primary.purple};
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 15px;
`;

export const ReqField = styled.div`
  color: red;
  font-size: 21px;
  font-weight: 400 !important;
`;

export const ContainerImgBanner = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  width: 542px;
  height: auto;
  border: ${({ color }) => `
1 px solid $ { color }
`};
  background-color: ${({ color }) => `
$ { color }
`};
`;

export const ImgBanner = styled.img`
  max-width: 100%;
  height: auto;
  width: auto/9;
  border-radius: 3px;
`;

export const EditButton = styled.button`
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  float: right;
  height: 40px;
  text-align: center;
  color: white;
  max-width: 80px;
`;

export const DeleteButton = styled.button`
  border: 1px solid ${({ theme }) => theme.primary.purple};
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  height: 40px;
  text-align: center;
  color: ${({ theme }) => theme.button.primary};
  float: right;
  font-size: 14px;
  font-weight: 500;
  max-width: 80px;
  &:hover {
    opacity: 0.9;
  }
`;
